import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Collapse from 'react-bootstrap/Collapse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { deleteAssembly } from 'product_tabs/tab_assembly/assemblySlice';

const assemblyProductNames = {
  'assembly-us': 'USA PCB Assembly',
  'assembly-mx': 'Mexico PCB Assembly'
}

const Assembly = ({ quantity, unitPrice, leadTime, subTotal, selected, supplier }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  if (!selected) return null;

  const onDelete = () => {
    setOpen(false);
    dispatch(deleteAssembly());
  };

  const onToggle = () => setOpen(!open);

  return (
    <div className="cart-section assembly">
      <div className="title">
        {assemblyProductNames[supplier]}
        <button type="button" onClick={onDelete} className="btn btn-link float-end btn-delete">
          <FontAwesomeIcon icon={faTrashCan} />
        </button>
      </div>
      <div className="position-relative">
        <div className="price">{subTotal !== undefined ? `$${subTotal}` : null}</div>
        <div className="toggle-details">
          <button type="button" className="btn btn-link p-0" onClick={onToggle}>
            {`${open ? 'LESS' : 'VIEW MORE'}`}
          </button>
        </div>
        <Collapse in={open}>
          <div>
            <div className="details">
              <div className="detail">
                <strong>Lead Time:</strong> {leadTime}
              </div>
              <div className="detail">
                <strong>Quantity:</strong> {quantity}
              </div>
              <div className="detail">
                <strong>Unit Price:</strong> {unitPrice !== undefined ? `$${unitPrice}` : null}
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  )
}

export default Assembly;